import { AppContainer } from 'react-hot-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import injectTapEventPlugin from 'react-tap-event-plugin';

import Root from './components/Root';

// The following from react-hot-loader boilerplate
const rootEl = document.getElementById('root');

// Needed for onTouchTap
// Can go away when react 1.0 release
// Check this repo:
// https://github.com/zilverline/react-tap-event-plugin
injectTapEventPlugin();

ReactDOM.render(
  <AppContainer component={Root} />,
  rootEl
);

if (module.hot) {
  module.hot.accept('./components/Root', () => {
    ReactDOM.render(
      <AppContainer component={require('./components/Root').default} />,
      rootEl
    );
  });
}



/** WEBPACK FOOTER **
 ** ./index.js
 **/